import React, { Component } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import { Grid, Row, Col } from "react-bootstrap";
import Select from 'react-select';

import { CustomCard } from "../../components/Card/CustomCard";
import Preloader from "../../views/Preloader/Preloader";

import NotasCertificadas from '../EstConsultas/NotasCertificadas';
import ConstanciaEstudios from '../EstConsultas/ConstanciaEstudios';
import CartaEgreso from '../EstConsultas/CartaEgreso';
import RetiroMaterias from "../EstAcademicos/RetiroMaterias";
import CambioCarrera from "../EstAcademicos/CambioCarrera";
import BecaEst from "../EstSolicitudes/BecaEst";
import CargaHoraria from '../EstConsultas/CargaHoraria';
import PensumProgramas from '../EstConsultas/PensumProgramas';
import ModalidadSimple from '../EstConsultas/ModalidadSimple';
import ModalidadCert from '../EstConsultas/ModalidadCert';
import CulminacionEst from '../EstConsultas/CulminacionEst';
import CulminacionEstCert from '../EstConsultas/CulminacionEstCert';
import ConductaCert from '../EstConsultas/ConductaCert';

import CheckData from '../../shared/CheckData';

let statusUser = 0;
class MainSolicitudesEst extends Component {
    state = {
        valorRegistro: { value: 'constancia_estudios', label: 'Constancia de Estudios (Simple)' },
        statusUser: 0,
    }

    constructor (props) {
        super (props);
        CheckData((resp) => {
            statusUser = parseInt(resp)
            this.setState ({
                statusUser: parseInt(resp)
            })
        });
    }

    Selecciona = (link) => {
        switch (link) {
            case "/est_solicitudes/constancia_estudios": return({ value: 'constancia_estudios', label: 'Constancia de Estudios (Simple)' })
            case "/est_solicitudes/notas_certificadas": return({ value: 'notas_certificadas', label: 'Notas Certificadas' })
            case "/est_solicitudes/cambio_carrera": return({ value: 'cambio_carrera', label: 'Cambio de Carrera' })
            case "/est_solicitudes/retiro_materias": return({ value: 'retiro_materias', label: 'Retiro de Materias' })
            case "/est_solicitudes/becas": return({ value: 'becas', label: 'Beca Estudiantil' })
            case "/est_solicitudes/carta_egreso": return({ value: 'carta_egreso', label: 'Carta de Egreso' })
            case "/est_solicitudes/carga_horaria": return({ value: 'carga_horaria', label: 'Carga Horaria' })
            case "/est_solicitudes/pensum_programas": return({ value: 'pensum_programas', label: 'Certificación Plan de Estudios (Pensum)' })
            case "/est_solicitudes/modalidad_estudios_simple": return({ value: 'modalidad_estudios_simple', label: 'Constancia de Modalidad de Estudio (Simple)' })
            case "/est_solicitudes/modalidad_estudios_cert": return({ value: 'modalidad_estudios_cert', label: 'Constancia de Modalidad de Estudio (Certificada)' })
            case "/est_solicitudes/culminacion_est": return({ value: 'culminacion_est', label: 'Constancia de Culminación de Estudio (Simple)' })
            case "/est_solicitudes/culminacion_est_cert": return({ value: 'culminacion_est_cert', label: 'Constancia de Culminación de Estudio (Certificada)' })
            case "/est_solicitudes/constancia_conducta_cert": return({ value: 'constancia_conducta_cert', label: 'Constancia de Buena Conducta (Certificada)' })
            default: return({ value: 'constancia_estudios', label: 'Constancia de Estudios (Simple)' })
        }
    }

    valorRegistroLabel = (link) => {
        switch (link) {
            case "/est_solicitudes/constancia_estudios": return('Constancia de Estudios')
            case "/est_solicitudes/notas_certificadas": return('Notas Certificadas')
            case "/est_solicitudes/cambio_carrera": return('Cambio de Carrera')
            case "/est_solicitudes/retiro_materias": return('Retiro de Materias')
            case "/est_solicitudes/becas": return('Beca Estudiantil')
            case "/est_solicitudes/carta_egreso": return('Carta de Egreso')
            case "/est_solicitudes/carga_horaria": return('Carga Horaria')
            case "/est_solicitudes/pensum_programas": return('Certificación Plan de Estudios (Pensum)')
            case "/est_solicitudes/modalidad_estudios_simple": return('Constancia de Modalidad de Estudio (Simple)')
            case "/est_solicitudes/modalidad_estudios_cert": return('Constancia de Modalidad de Estudio (Certificada)')
            case "/est_solicitudes/culminacion_est": return('Constancia de Culminacion de Estudio (Simple)')
            case "/est_solicitudes/culminacion_est_cert": return('Constancia de Culminacion de Estudio (Certificada)')
            case "/est_solicitudes/constancia_conducta_cert": return('Constancia de Buena Conducta (Certificada)')
            default: return('Constancia de Estudios (Simple)')
        }
    }

    contenido = () => {
        return (
            <Switch>
                <Route path="/est_solicitudes/constancia_estudios" component={ () => <ConstanciaEstudios/> } />
                <Route path="/est_solicitudes/notas_certificadas" component={ () => <NotasCertificadas/> } />
                <Route path="/est_solicitudes/cambio_carrera" component={ () => <CambioCarrera/> } />
                <Route path="/est_solicitudes/retiro_materias" component={ () => <RetiroMaterias/> } />
                <Route path="/est_solicitudes/becas" component={ () => <BecaEst/> } />
                <Route path="/est_solicitudes/carta_egreso" component={ () => <CartaEgreso/> } />
                <Route path="/est_solicitudes/carga_horaria" component={ () => <CargaHoraria/> } />
                <Route path="/est_solicitudes/pensum_programas" component={ () => <PensumProgramas/> } />
                <Route path="/est_solicitudes/modalidad_estudios_simple" component={ () => <ModalidadSimple/> } />
                <Route path="/est_solicitudes/modalidad_estudios_cert" component={ () => <ModalidadCert/> } />
                <Route path="/est_solicitudes/culminacion_est" component={ () => <CulminacionEst/> } />
                <Route path="/est_solicitudes/culminacion_est_cert" component={ () => <CulminacionEstCert/> } />
                <Route path="/est_solicitudes/constancia_conducta_cert" component={ () => <ConductaCert/> } />
                <Redirect to = "/est_solicitudes/constancia_estudios" />
            </Switch>
        )
    }

    valorSelectRegistro = (valorRegistro) => {
        this.setState({
            valorRegistro
        },() => {
            this.props.history.push(`/est_solicitudes/${this.state.valorRegistro.value}`);
        });
    }

    
    contenidOk = () => {
        let sortJSON = (data, key, orden) => {
            return data.sort(function (a, b) {
                let x = a[key],
                y = b[key];
        
                if (orden === 'asc')  return ((x < y) ? -1 : ((x > y) ? 1 : 0));
                if (orden === 'desc') return ((x > y) ? -1 : ((x < y) ? 1 : 0));
            });
        }

        const Registros = [
            { value: 'constancia_estudios', label: 'Constancia de Estudios (Simple)' },
            { value: 'notas_certificadas', label: 'Notas Certificadas' },
            { value: 'retiro_materias', label: 'Retiro de Materias' },
            { value: 'becas', label: 'Beca Estudiantil' },
            { value: 'carta_egreso', label: 'Carta de Egreso' },
            { value: 'carga_horaria', label: 'Carga Horaria' },
            { value: 'pensum_programas', label: 'Certificación Plan de Estudios (Pensum)' },
            { value: 'modalidad_estudios_simple', label: 'Constancia de Modalidad de Estudio (Simple)' },
            { value: 'modalidad_estudios_cert', label: 'Constancia de Modalidad de Estudio (Certificada)' },
            { value: 'culminacion_est', label: 'Constancia de Culminación de Estudios (Simple)' },
            { value: 'culminacion_est_cert', label: 'Constancia de Culminación de Estudios (Certificada)' },
            { value: 'constancia_conducta_cert', label: 'Constancia de Buena Conducta (Certificada)' },
            { value: 'cambio_carrera', label: 'Cambio de Carrera' },
        ];

        return (
            <div className="content">
                <Grid fluid>
                    <div className="custom-alert-info" style={{marginBottom:15, padding:10}}>
                        <Row>
                            <Col md={7}>
                                <div className="title" style={{fontSize:14, paddingTop: 10}}>
                                    Selecciona el tipo de Solicitud
                                </div>
                            </Col>
                            <Col md={5}>
                                <Select
                                    isSearchable ={true}
                                    value={this.Selecciona(this.props.history.location.pathname)}
                                    onChange={this.valorSelectRegistro}
                                    options={sortJSON(Registros, 'label', 'asc')}
                                />
                            </Col>
                        </Row>
                    </div>
                    <Row>
                        <Col md={12}>
                            <CustomCard
                                title={`Opciones de ${this.valorRegistroLabel(this.props.history.location.pathname)}`}
                                category=""
                                color="#a80012"
                                content={this.contenido()}
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }

    render() { 
        switch (statusUser) {
            case 0:
                return(<Preloader/>) 
            case 1:
                return (<Redirect to="/perfil" />)
            case 2:
                return (<Redirect to="/perfil" />)
            case 3:
                return (this.contenidOk())
            case 4:
                return (<Redirect to="/perfil" />)
            case 5:
                return (<Redirect to="/admision" />)
            default:
                return(<Preloader/>) 
        }
    }
}
 
export default MainSolicitudesEst;


// WEBPACK FOOTER //
// ./src/views/EstSolicitudes/MainSolicitudesEst.jsx